import { useSelector } from "react-redux";

// libs
import { Firestore } from "lib/firebase";

// reducers
import { selectUser } from "hyc-store/reducers/user";

const useActiveUser = () => {
    const user = useSelector(selectUser);

    if (!user) {
        return null;
    }

    const ref = Firestore.collection('employees').doc(user.id);
    return { ...user, ref };
}

export { useActiveUser };
